import { render, staticRenderFns } from "./AIChatWidget.vue?vue&type=template&id=2f69ce8d&scoped=true"
import script from "./AIChatWidget.vue?vue&type=script&lang=js"
export * from "./AIChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidget.vue?vue&type=style&index=0&id=2f69ce8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69ce8d",
  null
  
)

export default component.exports